var _excluded = ["children", "className", "onChangeDropdownVisibility", "placement", "offset"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useRef } from "react";
import { node, func, string, arrayOf, number, oneOf } from "prop-types";
import useOnClickOutside from "use-onclickoutside";
import classNamesMaker from "classnames";
import { usePopper } from "react-popper";
import { getAuthorizedRestProps } from "#library/utils/propsUtil";
import { hideDropdownMenu, setDropdownMenuPosition } from "./Dropdown.actions";
import { useDropdown } from "#library/components/Dropdown/components/Provider";
import { Item } from "#library/components/Dropdown/components/Item";
import { Menu } from "#library/components/Dropdown/components/Menu";
import { TriggerButton } from "#library/components/Dropdown/components/TriggerButton";
import { TriggerMenuItem } from "#library/components/Dropdown/components/TriggerMenuItem";
import styles from "./styles/dropdown.module.css";
export var DROPDOWN_MENU_PLACEMENTS = {
  AUTO: "auto",
  AUTO_START: "auto-start",
  AUTO_END: "auto-end",
  TOP: "top",
  TOP_START: "top-start",
  TOP_END: "top-end",
  BOTTOM: "bottom",
  BOTTOM_START: "bottom-start",
  BOTTOM_END: "bottom-end",
  RIGHT: "right",
  RIGHT_START: "right-start",
  RIGHT_END: "right-end",
  LEFT: "left",
  LEFT_START: "left-start",
  LEFT_END: "left-end"
};
export var defaultProps = {
  className: null,
  onChangeDropdownVisibility: function onChangeDropdownVisibility() {
    return null;
  },
  placement: DROPDOWN_MENU_PLACEMENTS.BOTTOM_START,
  offset: [0, 8] // dropdown has a 8px "margin" from trigger
};
export var Dropdown = function Dropdown(props) {
  var children = props.children,
    className = props.className,
    _props$onChangeDropdo = props.onChangeDropdownVisibility,
    onChangeDropdownVisibility = _props$onChangeDropdo === void 0 ? defaultProps.onChangeDropdownVisibility : _props$onChangeDropdo,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? defaultProps.placement : _props$placement,
    _props$offset = props.offset,
    offset = _props$offset === void 0 ? defaultProps.offset : _props$offset,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useDropdown = useDropdown(),
    state = _useDropdown.state,
    dispatch = _useDropdown.dispatch;
  var dropdownRef = useRef();
  var dropdownClassNames = classNamesMaker(styles["jds-Dropdown__container"], className);
  useEffect(function () {
    onChangeDropdownVisibility(state.isDropdownMenuVisible);
  }, [onChangeDropdownVisibility, state.isDropdownMenuVisible]);
  var _usePopper = usePopper(state.triggerButton, state.dropdownMenu, {
      placement: placement,
      modifiers: [{
        name: "offset",
        options: {
          offset: offset
        }
      }, {
        name: "flip"
      }]
    }),
    test = _usePopper.styles;
  useEffect(function () {
    if (test.popper) {
      dispatch(setDropdownMenuPosition(test.popper));
    }
  }, [dispatch, test.popper]);
  useOnClickOutside(dropdownRef, function () {
    return dispatch(hideDropdownMenu());
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, getAuthorizedRestProps(restProps), {
    ref: dropdownRef,
    className: dropdownClassNames
  }), children);
};
Dropdown.propTypes = {
  children: node.isRequired,
  className: string,
  onChangeDropdownVisibility: func,
  placement: oneOf(Object.values(DROPDOWN_MENU_PLACEMENTS)),
  // see https://popper.js.org/docs/v2/constructors/#options
  offset: arrayOf(number) // see https://popper.js.org/docs/v2/modifiers/offset/
};

// If edited, update them to index.js too.
Dropdown.Item = Item;
Dropdown.Menu = Menu;
Dropdown.TriggerButton = TriggerButton;
Dropdown.TriggerMenuItem = TriggerMenuItem;